import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div.withConfig({displayName:'-Wrapper'})`
	text-align: ${props => props.align};
  	padding: 40px 0px;
  	background-size: cover;
  	background-image: ${props => props.background ? "url('"+props.background+"')" : null};
	font-size: 16px;
	color: ${props => 
		props.variant === "white" ? "#212529" :
		props.variant === "blue" ? "#ffffff" :
		"#000000"
	};
`;


const Band = ({variant = "white", background=null, align="left", children}) => {
  return (
    <Wrapper variant={variant} background={background} align={align}>
		{children}      
    </Wrapper>
  )
}

export default Band;
